export const CMSFields = {
  TITLE: 'stepDetailsTitle',
  SUBTITLE: 'stepDetailsSubTitle',
};

export const Unpaid = '_Unpaid';
export const AddBenefits = '_AddBenefits';
